{
  "title": "Personal profile",
  "info": "Personal details",
  "idCopy": "Copy my ID",
  "copied": "ID copied",
  "copyFailed": "Could not copy ID",
  "name": "First name",
  "surname": "Last name",
  "birth": "Date of birth",
  "gender": "Gender",
  "chooseGender": "Select gender",
  "male": "Male",
  "female": "Female",
  "save": "Save",
  "saved": "Profile saved",
  "missing": "Please complete all personal details.",
  "failed": "Could not save profile.",
  "alreadySaved": "Personal details are confirmed and locked.",
  "confirmTitle": "Confirm your action",
  "confirmText": "Confirm that your details are accurate. After confirmation, changes require administrator approval.",
  "verify": "Confirm",
  "back": "Back",
  "contacts": "Contact details",
  "linked": "Connected",
  "notLinked": "Not connected",
  "unverified": "Unverified",
  "manage": "Manage",
  "telegram": "Telegram",
  "unavailable": "Not available",
  "phone": "Phone number",
  "email": "Email",
  "change": "Request a change",
  "pending": "Your change request is pending.",
  "requestTitle": "Change personal details",
  "changeHelp": "An administrator must approve changes.",
  "reason": "Reason for change",
  "submit": "Submit request",
  "noChanges": "No changes requested.",
  "changeFailed": "Request failed.",
  "changeSent": "Request sent to the administrator.",
  "support": "Contact support",
  "age": "Enter an accurate date of birth.",
  "loggingOut": "Signing out...",
  "logout": "Sign out"
}
